<template>
    <div class="item">
        <div class="icon">
            <visual :svg="icon" />
        </div>
        <div class="caption">
            <heading :level="5">
                <template v-if="date.datetime">
                    <cta
                        is-link
                        font-icon="fn_angleLink"
                        link="#"
                        type="text"
                        :content="date.day"
                        @click="downloadICS"
                    />
                </template>
                <template v-else>{{ date.day }}</template>
            </heading>
        </div>
    </div>
</template>

<script>
import Cta from 'gvue/src/core/Cta'
import Heading from 'gvue/src/core/Heading'
import Visual from 'gvue/src/core/Visual'

import getImage from '@/helpers/image'
import ics from '@/helpers/ics'

export default {
    name: 'ScheduleDate',
    components: {
        Cta,
        Heading,
        Visual
    },
    props: {
        date: { type: Object, required: true },
        header: { type: Object, required: true }
    },
    computed: {
        icon() {
            return getImage({
                type: 'icon',
                name: 'icon_calendar',
                landing: this.$landing
            })
        }
    },
    methods: {
        downloadICS() {
            const title = this.header.title.replace(/(<([^>]+)>)/gi, '')
            const text = this.header.text.replace(/(<([^>]+)>)/gi, '')
            const begin = new Date(this.date.datetime)
            const stop = new Date(begin.setHours(begin.getHours() + 2))

            const cal = ics()

            cal.addEvent(
                title,
                text,
                '',
                begin.toDateString(),
                stop.toDateString()
            )
            cal.download()
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import ScheduleItem
</style>
